<template>
  <el-tag v-bind="tagProps" v-on="$listeners">
    {{ displayLabel }}
  </el-tag>
</template>

<script>
export default {
  name: "StatusTag",
  props: {
    // 当前状态值
    value: {
      required: true,
    },
    // 状态映射表，key为状态值，value可以是字符串或配置对象
    // 字符串示例: { '1': '成功', '0': '失败' }
    // 对象示例: { '1': { label: '成功', type: 'success', effect: 'dark' }, '2': { label: '进行中', type: 'warning' } }
    statusMap: {
      type: Object,
      default: () => ({}),
    },
    // 未匹配时的默认文本（优先级高于 showRawValueOnNotFound）
    defaultLabel: {
      type: String,
      default: undefined,
    },
    // 未匹配时的默认 type（info/success/warning/danger）
    defaultType: {
      type: String,
      default: "info",
    },
    // 是否在未匹配且未提供 defaultLabel 时显示原始 value 值
    showRawValueOnNotFound: {
      type: Boolean,
      default: true,
    },
    // 未匹配时的其他 tag 属性（例如 effect、size、closable 等）
    defaultTagProps: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    // 匹配到的配置（原始值或处理后的标准对象）
    matchedConfig() {
      const map = this.statusMap;
      if (!map) return null;
      const matched = map[this.value];
      if (matched === undefined) return null;

      // 若配置为字符串，自动转为对象格式
      if (typeof matched === "string") {
        return { label: matched };
      }
      // 若配置为对象，直接返回
      if (typeof matched === "object") {
        return { ...matched };
      }
      return null;
    },
    // 传递给 el-tag 的属性（过滤掉 label，避免冗余绑定）
    tagProps() {
      if (this.matchedConfig) {
        const { label, ...restProps } = this.matchedConfig;
        return restProps;
      }
      // 未匹配时：合并 defaultTagProps 与 defaultType
      const defaultProps = { ...this.defaultTagProps };
      if (!defaultProps.type && this.defaultType) {
        defaultProps.type = this.defaultType;
      }
      return defaultProps;
    },
    // 最终显示的文本
    displayLabel() {
      // 匹配到配置时，优先使用配置中的 label
      if (this.matchedConfig) {
        if (this.matchedConfig.label !== undefined) {
          return this.matchedConfig.label;
        }
        // 若配置对象无 label 但有其他属性，回退显示原始值
        if (this.value !== undefined && this.value !== null) {
          return this.value;
        }
        return "";
      }

      // 未匹配时：优先使用 defaultLabel
      if (this.defaultLabel !== undefined) {
        return this.defaultLabel;
      }
      // 其次根据 showRawValueOnNotFound 决定是否显示原始值
      if (
        this.showRawValueOnNotFound &&
        this.value !== undefined &&
        this.value !== null
      ) {
        return this.value;
      }
      // 最终回退
      return "未知";
    },
  },
};
</script>

<style scoped>
/* 如需自定义全局样式，可在此添加，例如统一边距等 */
</style>



// WEBPACK FOOTER //
// src/components/StatusTag.vue